<template>
	<div class="pa-2">
		<v-delete-dialog
			v-model="deleteDialog"
			:module="'attendanceEmployee/delete'"
			:parameters="{ id: selectItem !== null ? selectItem.id : null }"
            @on-delete="fetch(search)">
			{{ $T('Attendance.delete-message-attendance') }}
		</v-delete-dialog>
		<v-row
			align="center"
			class="mb-2"
			dense>
			<v-col
				cols="12"
				sm="auto">
				<span>
					<strong>نظام الدوام: </strong>
					{{ attendanceType }}
					<v-progress-circular
						v-if="loadingAttendanceType || !employee"
						size="20"
						width="2"
						color="edit-color"
						indeterminate></v-progress-circular>
					|
				</span>
				<span>
					<strong>رقم جهاز البصمة: </strong>
					{{ employee.code }}
					<v-btn
						v-if="employee.status !== employeesTypes.former.value && !employee.code"
						:loading="loadingChangingCode"
						@click="showChangeCodeDialog = true"
						color="edit-color"
						icon
						x-small>
						<v-icon small>$edit</v-icon>
					</v-btn>
				</span>
				|
				<span cols="auto">
					مكان العمل:
					<span
						v-if="workLocation"
						class="font-weight-bold">
						{{ workLocation ? workLocation : '-' }}
					</span>
					<v-btn
						v-if="employee.status !== employeesTypes.former.value"
						:loading="loadingAddingPosition"
						@click="showMoveWorkLocationDialog = true"
						color="edit-color"
						icon
						x-small>
						<v-icon small>$edit</v-icon>
					</v-btn>
				</span>
			</v-col>

			<v-spacer></v-spacer>
			<v-divider
				vertical
				class="mx-1"></v-divider>
				
			<v-col cols="auto">
				<!-- export excel -->
				<v-btn  @click="exportFile()" :loading="excelLoading" class="mx-1" small color="success">
					<v-icon small class="pe-1"> mdi-export </v-icon>
					تصدير لإكسل
				</v-btn>
				<v-btn
					:disabled="
						!employee?.employeeId ||
						employee?.activePermanentSystem == '00000000-0000-0000-0000-000000000000' ||
						employee.status === employeesTypes.former.value
					"
					@click="showDialog = true"
					color="primary"
					small>
					<v-icon
						size="20"
						left>
						$add
					</v-icon>
					{{ $T('add') }}
				</v-btn>
				<div
					v-if="
						employee && employee.activePermanentSystem === '00000000-0000-0000-0000-000000000000'
					"
					class="text-caption">
					لا يوحد نظام دوام
				</div>
			</v-col>
		</v-row>

		<customizable-table
			:headers="headers"
			localStorageName="employee.attendance.work">
			<template v-slot:default="{ headers, openCustomizer }">
				<bee-handy-table
					ref="table"
					:headers="headers"
					:items="items"
					:loading="loading"
					:data-table-props="{ disableSort: true }"
					dense
					zebra
					fixed-header
					:row-highlight-expression="(e) => !e.valid"
					:row-highlight-expression-class="'is-absent-row'"
					:height="$vuetify.breakpoint.height - 230"
					:items-per-page="30"
					hide-default-footer>
					<template v-slot:item.type="{ item }">
						<v-icon
							small
							v-if="item.type === addingAttendanceTypeEnum.fingerPrints">
							mdi-fingerprint
						</v-icon>
						<v-badge
							v-if="item.type === addingAttendanceTypeEnum.fingerPrintsEdited"
							color="grey--text"
							icon="$edit"
							overlap
							left
							bottom>
							<v-icon small> mdi-fingerprint </v-icon>
						</v-badge>
						<v-icon
							small
							v-if="item.type === addingAttendanceTypeEnum.dialog">
							mdi-server-outline
						</v-icon>
						<v-badge
							v-if="item.type === addingAttendanceTypeEnum.dialogEdited"
							color="grey--text"
							icon="$edit"
							overlap
							left
							bottom>
							<v-icon small> mdi-server-outline </v-icon>
						</v-badge>
					</template>

					<template v-slot:item.actions="{ item }">
						<div class="d-flex">
							<tooltip :text="$T('tooltips.showFinderPrints')">
								<v-btn
									:loading="loadingFingerprint === item.id"
									:disabled="!!loadingFingerprint"
									small
									icon
									@click="fetchFingerprints(item)">
									<v-icon
										size="20"
										color="preview">
										mdi-fingerprint
									</v-icon>
								</v-btn>
							</tooltip>
							<tooltip :text="$T('tooltips.delete')">
								<v-btn
									small
									icon
									@click="selectItem = item; deleteDialog = true"
								>
									<v-icon
										size="20"
										color="alert">
										$delete
									</v-icon>
								</v-btn>
							</tooltip>
							<!-- <tooltip :text="$T('tooltips.preview')">
								<v-btn
									small
									icon>
									<v-icon
										size="20"
										color="preview">
										$view
									</v-icon>
								</v-btn>
							</tooltip> -->
							<!-- <tooltip :text="$T('tooltips.edit')">
								<v-btn
									small
									icon>
									<v-icon
										size="20"
										color="edit-color">
										$edit
									</v-icon>
								</v-btn>
							</tooltip>
							 -->
						</div>
					</template>

					<template v-slot:top="{}">
						<v-btn
							style="z-index: 3"
							class="me-n2"
							left
							absolute
							@click="openCustomizer"
							x-small
							depressed>
							تعديل
						</v-btn>
					</template>
				</bee-handy-table>
			</template>
		</customizable-table>

		<!-- add work dialog -->
		<v-dialog
			v-model="showDialog"
			max-width="400px"
			transition="dialog-transition">
			<b-add-work-day
				:one-employee="employeeId"
				@close="showDialog = false"
				@done="fetch(search)"></b-add-work-day>
		</v-dialog>

		<!-- fingerprints dialog -->
		<v-dialog
			v-model="showFingerprintDialog"
			max-width="600px"
			transition="dialog-transition">
			<b-fingerprint-dialog
				:loading-fetch="loadingFingerprint"
				:id="showFingerprintDialog"
				:data="fingerprints"
				:details="fingerprintDetails"
				:employee="employee?.personal?.firstName + ' ' + employee?.personal?.lastName"
				@close="showFingerprintDialog = null"
				@re-fetch="fetchFingerprints"></b-fingerprint-dialog>
		</v-dialog>

		<!-- workplace dialog -->
		<v-dialog
			v-model="showMoveWorkLocationDialog"
			width="300"
			transition="dialog-transition">
			<v-card elevation="3">
				<v-card-title primary-title>
					تغير مكان العمل
					<v-spacer></v-spacer>
					<v-btn
						@click="showMoveWorkLocationDialog = false"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-autocomplete
						v-model="selectedWorkLocations"
						:items="workLocations"
						:loading="!workLocations.length"
						:disabled="!workLocations.length"
						item-text="name"
						item-value="id"
						clearable
						dense
						outlined
						:label="$T('inputs.search-by-section')"
						hide-details></v-autocomplete>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						:loading="loadingAddingPosition"
						:disabled="loadingAddingPosition || !selectedWorkLocations"
						color="secondary"
						@click="changeWorkPosition">
						{{ $T('default-buttons.save') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- change code dialog -->
		<v-dialog
			v-model="showChangeCodeDialog"
			width="330"
			transition="dialog-transition">
			<v-card elevation="3">
				<v-card-title primary-title>
					تغير الكود في جهاز البصمة
					<v-spacer></v-spacer>
					<v-btn
						@click="showChangeCodeDialog = false"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					{{ "آخر كود تم الوصول له: " + lastNumberCode }}
					<v-text-field
						v-model="newCode"
						dense
						outlined
						hide-details></v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						:loading="loadingChangingCode"
						:disabled="loadingChangingCode || !newCode"
						color="secondary"
						@click="changeCode">
						{{ $T('default-buttons.save') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import attendance from './attendance';
import BAddWorkDay from '@/components/forms/BAddWorkDay.vue';
import BFingerprintDialog from '@/components/forms/BFingerprintDialog.vue';
import moment, { DATE_FORMAT, TIME_FORMAT, diff } from '@/utils/moment';
import { mapState } from 'vuex';
import { employeesTypes } from '@/utils/enum';

const addingAttendanceTypeEnum = {
	fingerPrints: 0,
	fingerPrintsEdited: 1,
	dialog: 2,
};

export default {
	name: 'WorkAttendance',

	mixins: [attendance],

	props: {
		search: { type: Object },
		employee: { type: Object },
		employeeId: { type: String },
		loadingFetchEmployee: { type: Boolean },
	},

	components: { BAddWorkDay, BFingerprintDialog },
	watch: {
		showChangeCodeDialog(val) {
			if(val) {
				this.$store.dispatch('employee/fetchLastCode').then((data) => {
					this.lastNumberCode = data
				})
			} else {
				this.newCode = null
			}
		}
	},
	data() {
		return {
			lastNumberCode: null,
			headers: [
				{ text: '', value: 'type', name: 'type', sortable: false, width: 0, cellClass: 'pe-0 ps-2' },
				{ 
					text: this.$T('headers.section-name'),
					value: 'section', 
					name: 'section', 
					setValueExpr: val => this.sections.find(c => c.id === val)?.name 
				},
				{
					text: this.$T('headers.date'),
					type: 'date',
					dateFormat: DATE_FORMAT,
					value: 'date',
					name: 'date',
				},
				{
					text: this.$T('headers.attendance.firstFinderPrint'),
					value: 'arrivalTime',
					name: 'arrivalTime',
					noNotAvailableText: false,
					setValueExpr: (value, index) =>
						moment(value).isValid() ? moment(value).format(TIME_FORMAT) : '-',
				},
				{
					text: this.$T('headers.attendance.lastFinderPrint'),
					value: 'departureTime',
					name: 'departureTime',
					setValueExpr: (value, index) =>
						moment(value).isValid() ? moment(value).format(TIME_FORMAT) : '-',
				},
				{
					text: this.$T('headers.attendance.duration'),
					value: 'duration',
					name: 'duration',
				},
				{
					text: this.$T('headers.attendance.delay'),
					value: 'delayArrivalInMinute',
					name: 'delay',
				},
				{
					text: this.$T('headers.attendance.earlyLeave'),
					value: 'earlyGoInMinute',
					name: 'earlyLeave',
				},
				{
					text: this.$T('headers.attendance.extraTotal'),
					value: 'overTimeInMinute',
					name: 'extra',
				},

				{
					text: this.$T('headers.attendance.fingerPrintCount'),
					value: 'fingerPrintCount',
					name: 'fingerPrintCount',
				},
				{
					text: this.$T('headers.attendance.unjustifiedTime'),
					value: 'unjustifiedTime',
					name: 'unjustifiedTime',
				},
				{
					text: this.$T('headers.attendance.durationToAll'),
					value: 'durationToAll',
					name: 'durationToAll',
				},
				{
					text: this.$T('headers.attendance.earlyLeaveToVacation'),
					value: 'earlyLeaveToVacation',
					name: 'earlyLeaveToVacation',
				},
				{
					text: this.$T('headers.attendance.lateArriveFromVacation'),
					value: 'lateArriveFromVacation',
					name: 'lateArriveFromVacation',
				},
				{
					text: this.$T('headers.attendance.vacationOverTime'),
					value: 'vacationOverTime',
					name: 'vacationOverTime',
				},
				{
					text: this.$T('headers.attendance.extraBefore'),
					value: 'extraBefore',
					name: 'extraBefore',
				},
				{
					text: this.$T('headers.attendance.extraAfter'),
					value: 'extraAfter',
					name: 'extraAfter',
				},
				{
					text: this.$T('headers.attendance.extraVacation'),
					value: 'extraVacation',
					name: 'extraVacation',
				},
			],

			storeModel: 'attendance/fetchAttendanceById',

			loadingAttendanceType: true,
			attendanceTypeItems: [],

			addingAttendanceTypeEnum,

			showDialog: false,
			showFingerprintDialog: false,

			loadingFingerprint: null,
			fingerprints: [],
			fingerprintDetails: null,

			showMoveWorkLocationDialog: false,
			loadingAddingPosition: false,

			showChangeCodeDialog: false,
			loadingChangingCode: false,
			newCode: null,

			selectedWorkLocations: null,
			employeesTypes,
			deleteDialog: false,
			selectItem: null,
			excelLoading: false
		};
	},

	computed: {
		workLocation() {
			if (!this.workLocations) return;
			const value = this.workLocations.find((e) => e.id === this.employee?.workPlaceId?.[0]);
			if (!value) return;
			return value.name;
		},
		attendanceType() {
			if (this.loadingAttendanceType || !this.attendanceTypeItems?.length) return;
			const value = this.attendanceTypeItems.find((e) => e.id === this.employee?.activePermanentSystem);
			if (!value) return;
			return value.name;
		},
		...mapState({
			workLocations: (state) => state.positions.workLocations,
			sections: state => state.section.sections
		}),
	},

	methods: {
		fetchAttendanceTypes() {
			this.loadingAttendanceType = true;
			this.$store
				.dispatch('attendance/fetchAttendanceTypes')
				.then((res) => {
					this.attendanceTypeItems = res;
				})
				.catch((e) => {
					e.default && e.default();
				})
				.finally(() => {
					this.loadingAttendanceType = false;
				});
		},
		fetchFingerprints(item) {
			this.fingerprints = [];
			this.loadingFingerprint = item.id;
			this.$store
				.dispatch('attendance/getFingerprint', {
					date: item.date,
					employeeCode: this.employee.code,
				})
				.then((res) => {
					this.fingerprints = res;
					this.fingerprintDetails = {
						id: item.id,
						employeeId: item.employeeId,
						name: item.name,
						date: item.date,
					};
					this.showFingerprintDialog = true;
				})
				.finally(() => {
					this.loadingFingerprint = null;
				});
		},

		changeWorkPosition() {
			this.loadingAddingPosition = true;
			this.$store
				.dispatch('positions/addWorkPosition', {
					id: this.$route.query.employeeId,
					workPlaceId: this.selectedWorkLocations,
				})
				.then(() => {
					this.$emit('fetch-employee');
					this.$eventBus.$emit('show-snackbar', this.$T('messages.add-done'), { done: true });
					this.showMoveWorkLocationDialog = false;
				})
				.catch((err) => {
					err.default && err.default(this.$T('messages.add-fail'), false);
				})
				.finally(() => {
					this.loadingAddingPosition = false;
				});
		},
		changeCode() {
			this.loadingChangingCode = true;
			this.$store
				.dispatch('employee/changeCode', {
					id: this.employeeId,
					code: this.newCode,
				})
				.then(() => {
					this.$emit('fetch-employee');
					this.$eventBus.$emit('show-snackbar', this.$T('messages.add-done'), { done: true });
				})
				.catch((err) => {
					err.default && err.default(this.$T('messages.add-fail'), false);
				})
				.finally(() => {
					this.newCode = null;
					this.showChangeCodeDialog = false;
					this.loadingChangingCode = false;
				});
		},
		diff,

		exportFile() {
			this.excelLoading = true
			this.$store.dispatch('reports/fetchExcelAttnEmp', {
				dateFrom : this.search.DateFrom,
				dateTo: this.search.DateTo,
				employeeId:this.$route.query.employeeId
			}).then((data) => {
				console.log(data)
			}).finally(() => {
				this.excelLoading = false
			})
		}
		
	},

	mounted() {
		this.fetch(this.search);
		this.fetchAttendanceTypes();
	},
};
</script>

<style lang="scss" scoped></style>
